import { singleAction } from '../launch/LaunchSequence';
import StateObserver, { user } from 'src/StateObserver';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { Feature } from 'src/replicant/analytics';
import * as Promo from 'src/replicant/promo';
import features from 'src/replicant/ruleset/features';
import i18n from 'src/lib/i18n/i18n';
import {
  jankenIsAvailable,
  jankenIsEventActive,
} from 'src/replicant/janken/janken.getters';
import { JANKEN_UNLOCK_LEVEL } from 'src/replicant/janken/janken.ruleset';
import {
  isJankenInviteEntry,
  isJankenResultEntry,
  jankenInviteEntrySequence,
  jankenResultEntrySequence,
  jankenSenderSequence,
} from './janken.sequence';

// Tracks whether janken was already shown during this launch.
// Used by the promo block to avoid showing redundant popups.
let _jankenShownDuringLaunch = false;

export const jankenLaunchSequence = [
  /**
   * Invite link entry → receiver flow (resolve challenge from entry data).
   */
  singleAction({
    enabled: ({ user }) => features(user).petJanken && isJankenInviteEntry(),
    action: async () => {
      _jankenShownDuringLaunch = true;

      if (jankenIsAvailable(user())) {
        await jankenInviteEntrySequence('launch');
      } else {
        await openPopupPromise('popupModalWhite', {
          title: i18n('janken.title'),
          message: i18n('lock.longText', { unlockAt: JANKEN_UNLOCK_LEVEL }),
          tracking: {
            feature: Feature.JANKEN._,
            $subFeature: Feature.JANKEN.BLOCKED,
          },
        });
      }

      return false;
    },
  }),

  /**
   * OA result entry → show the matching sender pending result.
   */
  singleAction({
    enabled: ({ user }) => jankenIsAvailable(user) && isJankenResultEntry(),
    action: async () => {
      const shown = await jankenResultEntrySequence('launch');
      if (shown) _jankenShownDuringLaunch = true;
      return false;
    },
  }),

  /**
   * Janken event promo — launches sender sequence (tutorial + challenge).
   * Skipped if janken was already shown this launch or suppressFeatureIntros
   * is active (centralized featureIntroBlock handles it).
   */
  singleAction({
    enabled: ({ user }, now) =>
      jankenIsEventActive(user, now) &&
      Promo.getters.isPromoReady(user, 'jankenEventPromo', now),
    action: async () => {
      // Bail out BEFORE consuming the legacy promo cooldown — otherwise
      // treatment users would burn the cooldown for a popup that never shows.
      if (features(user()).suppressFeatureIntros) return false;
      if (_jankenShownDuringLaunch) return false;

      await StateObserver.invoke.promoWasShown('jankenEventPromo');
      await jankenSenderSequence('launch');
      return false;
    },
  }),
];
